import { BreadcrumbDivider } from "./Icons";
import Link from "next/link";
import { prefix, localizePath } from "../../utils/utils";
import { getWebsiteType } from "../../utils/utils";
import Head from "next/head";

export default function Breadcrumbs({
  breadcrumbs,
  locale,
  defaultLocale,
  isLight = false,
}) {
  const websiteType = getWebsiteType(false);

  function getSiteUrl(websiteType = null) {
    const type = websiteType;

    switch (type) {
      case "petrotec":
        return "https://www.petrotec.com";
      case "petroassist":
        return "https://www.petroassist.com";
      case "petrotec-group":
        return "https://group.petrotec.com";
      default:
        return "https://group.petrotec.com";
    }
  }

  const siteUrl = getSiteUrl(websiteType);

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: breadcrumbs.map((crumb, index) => {
      const fullUrl = `${siteUrl}${localizePath(crumb.href, locale, defaultLocale)}`;
      console.log(`🔍 URL para "${crumb.name}":`, fullUrl); // Debug cada URL
      return {
        "@type": "ListItem",
        position: index + 1,
        name: crumb.name,
        item: fullUrl,
      };
    }),
  };

  return (
    <>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(breadcrumbSchema),
          }}
        />
      </Head>
      <ol className="absolute top-12 flex flex-wrap gap-10">
        {breadcrumbs.map((crumb, index) => (
          <li className="flex items-center gap-10" key={index}>
            <Link
              href={prefix(crumb.href)}
              as={prefix(crumb.href)}
              className={`text-xxxs font-medium tracking-05 ${
                isLight ? "text-gray-100" : "text-gray-500"
              }`}
              aria-label={crumb.name || ""}
            >
              {crumb.name}
            </Link>
            {index + 1 < breadcrumbs.length && (
              <BreadcrumbDivider
                extraClass={isLight ? "stroke-gray-100" : "stroke-[#78838C]"}
              />
            )}
          </li>
        ))}
      </ol>
    </>
  );
}
